/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function n(n) {
  return n.split(",").map(function (n) {
    return n.trim();
  });
}

function t(n, t) {
  return n.map(function (n) {
    return r(n, t);
  });
}

function r(n, t) {
  return 0 === n.indexOf(t) ? n : "".concat(t, ".").concat(n);
}

export { t as normalizePropNames, n as splitProps };